module.exports = __webpack_public_path__ + "media/images/icons/SVG/028-c6b7fa15a41edf3597923a0bcac72179.svg";